import React from "react"
import GroupBy from "../../../../../../../gd/manager/group-by/group-by-model";
import FieldProto from "../../../../../../../fields3/proto/field-proto";
import VScroll from "../../../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";

type Props = {
    menuParams: {
        groupBy?    : GroupBy
        field       : FieldProto
        onClick     : func
    }
    hidePopover: func
}

// const debug = "FieldItemWithOptions_Popover"
const debug = false

export default function FieldItemWithOptions_Popover(props: Props) {

    debug && console.log(debug, 'render', props)

    const onClick = (option: Option) => {
        debug && console.log(debug, 'onClick', option)

        props.menuParams.onClick(option)
        props.hidePopover()
    }

    const paramValue = props.menuParams.groupBy?.params[props.menuParams.field.modifierOptionParamName!]

    return (
        <VScroll containerClass="more-menu ui5-popover-menu w-200">
            {_.map(props.menuParams.field.modifierOptions, option=>{

                const classes = Classes("option", {
                    "selected": option.value === paramValue
                })

                return (
                    <div key={option.value} className={classes} onClick={()=>{onClick(option)}}>
                        <div className="label">{option.label}</div>
                    </div>
                )
            })}
        </VScroll>
    )
}